// Per-tab mirror /o/:orgId URL segment. Single writer: app's route
// resolver. Read at request time by Discover request interceptor,
// runs outside React cannot route parameter.
const ACTIVE_ORG_STORAGE_KEY = "peek.activeOrganizationId";
const listeners = new Set();
const notify = (id) => {
    listeners.forEach((listener) => listener(id));
};
const getActiveOrgId = () => {
    try {
        return sessionStorage.getItem(ACTIVE_ORG_STORAGE_KEY);
    }
    catch (_a) {
        return null;
    }
};
const setActiveOrgId = (id) => {
    try {
        sessionStorage.setItem(ACTIVE_ORG_STORAGE_KEY, id);
    }
    catch (_a) {
        // Storage denied mode edge cases): requests fall back headerless.
    }
    notify(id);
};
const clearActiveOrg = () => {
    try {
        sessionStorage.removeItem(ACTIVE_ORG_STORAGE_KEY);
    }
    catch (_a) {
        // ignore
    }
    notify(null);
};
const subscribeActiveOrg = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};
/**
 * Discover error codes that mean the mirror above is stale rather than the request being wrong:
 * the backend resolves memberships from peek-auth policies on every request, so an organization
 * the app authorized this session can stop being held mid-session (access revoked elsewhere).
 * `wrong_organization` is deliberately absent — there the mirror is fine and the deep link is not.
 */
const ACTIVE_ORG_REJECTION_CODES = ["invalid_active_organization", "no_organizations"];
const rejectionListeners = new Set();
/**
 * Announced by the Discover response interceptor. The app owns the recovery (it knows the routes
 * and holds the membership mirror); this util only carries the news out of the interceptor, which
 * runs outside React.
 */
const notifyActiveOrgRejected = (errorCode) => {
    rejectionListeners.forEach((listener) => listener(errorCode));
};
const subscribeActiveOrgRejected = (listener) => {
    rejectionListeners.add(listener);
    return () => rejectionListeners.delete(listener);
};

export { ACTIVE_ORG_REJECTION_CODES, ACTIVE_ORG_STORAGE_KEY, clearActiveOrg, getActiveOrgId, notifyActiveOrgRejected, setActiveOrgId, subscribeActiveOrg, subscribeActiveOrgRejected };
